<div class="container">
    <div class="text-center">
        <h1 class="fs-3 fw-bold" style="color: #8E0E00;">Sales Dashboard</h1>
    </div>

    <div class="row">
        <!-- Dropdowns Container -->
        <div class="card shadow p-3 col-12 mt-2 pb-0 cardRadius">
            <div class="row g-2 pb-4">
                <!-- City Dropdown -->
                <div class="col-lg-3 col-sm-6">
                    <div class="custom-dropdown">
                        <label for="typeOfUser" class="form-label">Select City</label>
                        <select (change)="onCityChange()" class="form-select" [(ngModel)]="cityId">
                            <option value="">All</option>
                            <option *ngFor="let city of cities" [value]="city?.id">{{ city?.cityName }}</option>
                        </select>
                    </div>
                </div>

                <!-- Zone Dropdown -->
                <div class="col-lg-3 col-sm-6">
                    <div class="custom-dropdown">
                        <label for="typeOfUser" class="form-label">Select Zone</label>
                        <select (change)="onZoneChange()" class="form-select" [(ngModel)]="zoneId">
                            <option value="">All</option>
                            <option *ngFor="let zone of zones" [value]="zone.zoneId">{{ zone?.zoneName }}</option>
                        </select>
                    </div>
                </div>

                <!-- Year Dropdown -->
                <div class="col-lg-3 col-sm-6">
                    <div class="custom-dropdown">
                        <label for="typeOfUser" class="form-label">Select Year</label>
                        <select (change)="onYearChange()" class="form-select" [(ngModel)]="year">
                            <option value="">All</option>
                            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Amount allocated to dumpster and dumpyard -->

    <div class="row">
        <div class="col-lg-10 col-md-8 col-sm-12">
            <div class="card shadow cardRadius mt-3 p-2">
                <div class="custom-modal-header">
                    <h1 class="text-start fs-5 ms-2 mt-2">Total achieved containers</h1>
                </div>
                <apx-chart [series]="chartSingleSeries" [chart]="chartSingleOptions.chart"
                    [xaxis]="chartSingleOptions.xaxis" [yaxis]="chartSingleOptions.yaxis"
                    [legend]="chartSingleOptions.legend" [colors]="chartSingleOptions.colors"
                    [plotOptions]="chartSingleOptions.plotOptions" [dataLabels]="chartSingleOptions.dataLabels">
                </apx-chart>
            </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
            <div class="card shadow cardRadius p-3 mt-3">
                <h1 class="text-center fs-3" style="color: #3e1a33;"><strong>{{ summary?.totalTripCount }}</strong></h1>
                <p class="text-center">Total achieved containers</p>
            </div>
            <div class="card shadow cardRadius p-3 mt-3">
                <h1 class="text-center fs-3" style="color: #FFBF00;"><strong>{{ summary?.totalTons }}</strong></h1>
                <p class="text-center">Total waste disposed (m³)</p>
            </div>
        </div>
    </div>

    <!-- Amount allocated to smart-sort -->
</div>


<div class="card p-3 mt-3" *ngIf="isTableVisible">
    <!-- From Date -->
    <div class="row g-3 ms-auto">
        <!-- From Date -->
        <div class="col-auto d-flex align-items-center">
            <label for="fromDate" class="form-label me-2 text-nowrap">From Date:</label>
            <input type="date" id="fromDate" (change)="onFromDateChange($event)" class="form-control" />
        </div>

        <!-- To Date -->
        <div class="col-auto d-flex align-items-center">
            <label for="toDate" class="form-label me-2 text-nowrap">To Date:</label>
            <input type="date" id="toDate" (change)="onToDateChange($event)" class="form-control" />
        </div>
    </div>

    <div class="table-responsive mt-2">
        <table class="table table-striped table-bordered text-center mb-0">
            <thead class="table-light">
                <tr>
                    <th>Order ID</th>
                    <th>City</th>
                    <th>Scheduled Start Date</th>
                    <th>Scheduled End Date</th>
                    <th>Number Of Containers</th>
                    <th>Planned Trips</th>
                    <th>Actual Trips</th>
                    <th>Quantity Disposed ( m³ )</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let order of orderSummaryData">
                    <td>{{ order.orderId }}</td>
                    <td>{{ order.city }}</td>
                    <td>{{ order.scheduleStartDate | date : "dd MMM yyyy" }}</td>
                    <td>{{ order.scheduleEndtDate | date : "dd MMM yyyy"}}</td>
                    <td>{{ order.numberOfContainers }}</td>
                    <td>{{ order.plannedTrips }}</td>
                    <td>{{ order.actualTrips }}</td>
                    <td>{{ order.totalQuantityDisposed }}</td>
                </tr>
                <tr *ngIf="orderSummaryData?.length == 0">
                    <td colspan="8" class="text-center">No Data Found</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>